import type { LanguageCode, SpeedKey } from "@shared/types";

export const languages: Record<LanguageCode, { name: string; flag: string; locales: { value: string; label: string }[]; speech: string }> = {
  en: { name: "Inglês", flag: "🇺🇸", speech: "en-US", locales: [{ value: "en-US", label: "Estados Unidos" }, { value: "en-GB", label: "Reino Unido" }, { value: "en-AU", label: "Austrália" }] },
  es: { name: "Espanhol", flag: "🇪🇸", speech: "es-ES", locales: [{ value: "es-ES", label: "Espanha" }, { value: "es-MX", label: "México" }, { value: "es-AR", label: "Argentina" }, { value: "es-CO", label: "Colômbia" }] },
  fr: { name: "Francês", flag: "🇫🇷", speech: "fr-FR", locales: [{ value: "fr-FR", label: "França" }, { value: "fr-CA", label: "Canadá / Quebec" }, { value: "fr-BE", label: "Bélgica" }] },
  zh: { name: "Chinês mandarim", flag: "🇨🇳", speech: "zh-CN", locales: [{ value: "zh-CN", label: "China continental" }, { value: "zh-TW", label: "Taiwan" }] }
};

export const speedOptions: { value: SpeedKey; label: string; rate: number }[] = [
  { value: "extremely_slow", label: "Extremamente lento", rate: 0.55 },
  { value: "very_slow", label: "Muito lento", rate: 0.7 },
  { value: "slow", label: "Lento", rate: 0.85 },
  { value: "normal", label: "Normal", rate: 1 },
  { value: "fast", label: "Rápido", rate: 1.18 },
  { value: "very_fast", label: "Mais rápido", rate: 1.35 }
];
